(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fw-family-assessment"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('fw-family-assessment')) return;

function safeLink(value) {
  if (typeof value !== 'string') return '';
  const s=value.trim();
  if (/^https?:\/\//i.test(s) || /^\/(?!\/)/.test(s)) return s;
  return '';
}
function buildConfig(payload) {
  const c=JSON.parse(JSON.stringify(payload.defaults));
  for (const [k,v] of Object.entries(payload.theme || {})) if(k in c.theme && v!==null) c.theme[k]=v;
  for (const b of payload.blocks || []) {
    const s=b.settings || {};
    if(b.type==='introduction'||b.type==='guide') for(const [k,v] of Object.entries(s)) if(k in c && v!==null)c[k]=v;
    if(b.type==='labels') for(const [k,v] of Object.entries(s)) if(k in c.labels && v!==null)c.labels[k]=v;
    if(b.type==='answers') {
      for(let i=0;i<4;i++) if(s['option'+i]!=null)c.options[i]=s['option'+i];
      for(let i=0;i<3;i++) if(s['question'+i]!=null)c.questionLabels[i]=s['question'+i];
    }
    if(/^area_[1-5]$/.test(b.type)) {
      const a=c.sections[Number(b.type.slice(-1))-1];
      if(s.title!=null)a.title=s.title;if(s.short!=null)a.short=s.short;
      for(let i=0;i<3;i++)if(s['q'+(i+1)]!=null)a.questions[i]={title:s['q'+(i+1)],statements:[s['q'+(i+1)]]};
    }
    if(/^result_[1-3]$/.test(b.type))Object.assign(c.results[Number(b.type.slice(-1))-1],s);
  }
  const guideBlock=(payload.blocks||[]).find(b=>b.type==='guide');
  if(guideBlock && Object.hasOwn(guideBlock.settings,'guideUrl'))c.guideUrl=guideBlock.settings.guideUrl || '';
  c.guideUrl=safeLink(c.guideUrl);c.results.forEach(r=>r.url=safeLink(r.url));
  return c;
}

  class FWFamilyAssessment extends HTMLElement {
    connectedCallback() {
      if(this.shadowRoot)return;
      // Shopify may insert the custom element before its children have parsed.
      if(!this.querySelector('[data-fw-config]') || !this.querySelector('template')) {
        if(!this._observer){this._observer=new MutationObserver(()=>this.connectedCallback());this._observer.observe(this,{childList:true});}
        return;
      }
      if(this._observer){this._observer.disconnect();this._observer=null;}
      const host=this;
      try {
        const payload=JSON.parse(this.querySelector('[data-fw-config]').getAttribute('data-fw-config'));
        const root=this.attachShadow({mode:'open'});
        root.appendChild(this.querySelector('template').content.cloneNode(true));
        this._afterPrint=()=>this.removeAttribute('data-fw-print');
        window.addEventListener('afterprint',this._afterPrint);
let config=buildConfig(payload),answers=Array(15).fill(null),step=0,screen='intro';
const $=s=>root.querySelector(s),esc=s=>String(s).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
function applyTheme(){for(const [k,v] of Object.entries(config.theme))host.style.setProperty('--'+k,typeof v==='number'&&!['mobileScale','lineHeight'].includes(k)?v+'px':v);$('#brand').textContent=config.brand;$('#footer').textContent=config.footer;if($('#customize'))$('#customize').textContent=config.labels.customize+' ⚙';}
function questions(){return config.sections.flatMap((s,si)=>s.questions.map(q=>({...q,si})));}
function score(a=answers){const totals=config.sections.map((s,si)=>s.questions.reduce((sum,q,qi)=>sum+(a[si*3+qi]??0),0));const total=totals.reduce((a,b)=>a+b,0);return{total,totals,band:total<=15?0:total<=30?1:2};}
const compass='<svg class="compass" viewBox="0 0 80 80" fill="none" aria-hidden="true"><circle cx="40" cy="40" r="30" stroke="currentColor"/><circle cx="40" cy="40" r="22" stroke="currentColor" opacity=".35"/><path d="M40 4v10m0 52v10M4 40h10m52 0h10M47 31 40 52 33 31 40 22Z" stroke="currentColor"/><path d="m40 22 7 9-7 9Z" fill="currentColor"/></svg>';
function render(){applyTheme();const l=config.labels;if(screen==='intro'){$('#app').innerHTML=`<div class="hero"><div class="hero-copy"><p class="eyebrow">${esc(config.eyebrow)}</p><h1>${esc(config.title)}</h1><p class="subtitle">${esc(config.subtitle)}</p><p class="lead">${esc(config.lead)}</p><p>${esc(config.intro)}</p><p>${esc(config.instruction)}</p><button class="primary" id="start">${esc(l.start)} <span aria-hidden="true">→</span></button><p class="note hero-note">${esc(config.disclaimer)}</p></div><aside class="overview">${compass}<h2>${esc(config.overviewTitle)}</h2><p class="overview-time">${esc(config.overviewText)}</p><p class="overview-closing">${esc(config.overviewClosing)}</p></aside></div>`;$('#start').onclick=()=>{screen='quiz';render();focusMain();};}
else if(screen==='quiz'){
const section=config.sections[step],count=answers.filter(x=>x!==null).length,start=step*3;
const complete=()=>answers.slice(start,start+3).every(x=>x!==null);
const subtotal=()=>answers.slice(start,start+3).reduce((sum,x)=>sum+(x??0),0);
$('#app').innerHTML=`<div class="quiz-shell"><div class="progress-meta"><span>${esc(l.section)} ${step+1} ${esc(l.of)} 5</span><span>${count}/15 ${esc(l.answered)}</span></div><div class="track" role="progressbar" aria-label="Questions answered" aria-valuemin="0" aria-valuemax="15" aria-valuenow="${count}"><div style="width:${count/15*100}%"></div></div><article class="card"><p class="question-context">${esc(l.section)} ${step+1} / 5 · ${esc(section.short)}</p><h2>${step+1}. ${esc(section.title)}</h2><p class="note">${esc(l.choose)}</p>${section.questions.map((q,qi)=>`<fieldset class="assessment-question"><legend><span class="question-letter">${esc(config.questionLabels[qi])}</span><strong>${esc(q.statements[0])}</strong></legend><div class="answers">${config.options.map((o,i)=>`<label class="answer"><input type="radio" name="answer-${qi}" data-question="${qi}" value="${i}" ${answers[start+qi]===i?'checked':''}><span><b>${i} — </b>${esc(o)}</span></label>`).join('')}</div></fieldset>`).join('')}<div class="section-subtotal" aria-live="polite"><strong>${esc(l.sectionTotal)}: <span id="subtotal">${complete()?subtotal():'—'}</span> / 9</strong><p class="note" id="sectionHint">${complete()?'':esc(l.sectionPending)}</p></div></article><div class="navigation"><button class="secondary" id="back">← ${esc(l.back)}</button><button class="primary" id="next" ${complete()?'':'disabled'}>${esc(step===4?l.finish:l.next)} <span aria-hidden="true">→</span></button></div><p class="quiz-note">${esc(config.disclaimer)}</p></div>`;
root.querySelectorAll('[data-question]').forEach(el=>el.onchange=()=>{const qi=Number(el.dataset.question);answers[start+qi]=Number(el.value);$('#next').disabled=!complete();$('#subtotal').textContent=complete()?String(subtotal()):'—';$('#sectionHint').textContent=complete()?'':l.sectionPending;const n=answers.filter(x=>x!==null).length;$('.progress-meta span:last-child').textContent=n+'/15 '+l.answered;$('.track').setAttribute('aria-valuenow',n);$('.track>div').style.width=n/15*100+'%';});
$('#back').onclick=()=>{if(step===0)screen='intro';else step--;render();focusMain();};$('#next').onclick=()=>{if(!complete())return;if(step<4)step++;else if(answers.every(x=>x!==null))screen='results';render();focusMain();};
}
else{if(answers.some(x=>x===null)){screen='quiz';step=Math.floor(answers.indexOf(null)/3);return render();}const {total,totals,band}=score(),r=config.results[band],min=Math.min(...totals),lowest=config.sections.filter((_,i)=>totals[i]===min).map(s=>s.short).join(' · ');const ranges=['0–15','16–30','31–45'];const target='#guide';$('#app').innerHTML=`<div class="result-header"><p class="eyebrow">${esc(l.resultEyebrow)}</p><div class="score" aria-label="${total} out of 45">${total}<small>/ 45</small></div><h1>${esc(r.title)}</h1><p>${esc(r.body)}</p><p class="note">${esc(config.disclaimer)}</p></div><div class="results-grid"><section class="card"><p class="eyebrow">${ranges[band]} / 45</p><p>${esc(r.ask)}</p><blockquote class="reflection">“${esc(r.prompt)}”</blockquote><p>${esc(r.pitch)}</p><a class="primary" href="${esc(target)}">${esc(r.button)} →</a></section><section class="card"><h2>${esc(l.breakdown)}</h2><div class="breakdown">${config.sections.map((s,i)=>`<div class="section-row"><div class="section-label"><span>${esc(s.short)}</span><strong>${totals[i]} / 9</strong></div><div class="track"><div style="width:${totals[i]/9*100}%"></div></div></div>`).join('')}</div><p class="note" style="margin-bottom:0">${esc(l.lowest)}<br><strong>${esc(lowest)}</strong></p></section></div><section class="guide" id="guide"><p class="eyebrow">${esc(config.brand)}</p><h2>${esc(config.guideTitle)}</h2><p>${esc(config.guideIntro)}</p><p><b>${esc(config.guideName)}</b> ${esc(config.guideBody)}</p><strong>${esc(config.guideQuestion)}</strong><p>${esc(config.guideEnd)}</p><div class="guide-action">${config.guideUrl||r.url?`<a class="primary guide-cta" href="${esc(config.guideUrl||r.url)}"><span>${esc(config.guideButton)}</span><span aria-hidden="true">→</span></a>`:`<button type="button" class="primary guide-cta" disabled><span>${esc(config.guideButton)}</span><span aria-hidden="true">→</span></button>`}</div></section><div class="result-actions"><button class="secondary" id="review">${esc(l.review)}</button><button class="secondary" id="print">${esc(l.print)}</button><button class="quiet" id="retake">${esc(l.retake)}</button></div>`;$('#review').onclick=()=>{step=0;screen='quiz';render();focusMain();};$('#retake').onclick=()=>{answers=Array(15).fill(null);step=0;screen='intro';render();focusMain();};$('#print').onclick=()=>{host.setAttribute('data-fw-print','');window.print();};}}
function focusMain(){const el=$('#app h1')||$('#app h2');el.setAttribute('tabindex','-1');el.focus({preventScroll:true});el.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}

root.addEventListener('click',e=>{const link=e.target.closest('a[href="#guide"]');if(link){e.preventDefault();const guide=$('#guide');guide.setAttribute('tabindex','-1');guide.focus({preventScroll:true});guide.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});}});
$('#brand').onclick=e=>{e.preventDefault();screen='intro';render();};
render();

      } catch(error) {
        const message=document.createElement('p');
        message.textContent='The assessment could not load. Please refresh the page or contact Forever Written.';
        (this.shadowRoot || this).appendChild(message);
        console.error('Family assessment:',error);
      }
    }
    disconnectedCallback(){if(this._observer)this._observer.disconnect();if(this._afterPrint)window.removeEventListener('afterprint',this._afterPrint);}
  }
  customElements.define('fw-family-assessment',FWFamilyAssessment);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-custom-general"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-custom-name-only"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-custom-name"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-custom-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
